export default __webpack_public_path__ + "static/media/stack-slider.3df80f3e.png";